<template>
    <div class="row mt-4">
        <div class="col-xl-12 mb-3">
            <h2 class="ml-3">Evolution du nombre de {{ metrique == "all_patients" ? "patients" : (metrique == "all_souscripteurs" ? "souscripteurs" : "praticiens")}} de {{ debut }} à {{ fin }}</h2>
        </div>
        <div class="col-md-12">
            <canvas id="planet-chart"></canvas>
        </div>
        <div class="col-xl-12 mt-5 mb-3">
            <h2 class="ml-3">Evolution cumulés du nombre de {{ metrique == "all_patients" ? "patients" : (metrique == "all_souscripteurs" ? "souscripteurs" : "praticiens")}} de {{ debut }} à {{ fin }}</h2>
        </div>
        <div class="col-md-12">
            <canvas id="planet-chart-cumules"></canvas>
        </div>

    </div>
  </template>

  <script>
  import {mapGetters} from "vuex";
  import Vue from 'vue';
  import _ from "lodash";
  import AppConfig from "../../constants/AppConfig";
  import router from "../../router/router";
  import Chart from 'chart.js'
  export default {
    name: "prise-charge",
    computed: {
      ...mapGetters(["notif_validation_prix", 'hasAdminRole', 'hasGestionnaireRole', 'hasPraticienRole', 'hasMedecinControleRole'])
    },
    data(){
      return {
        debut: "",
        fin: "",
        metrique: ""
      }
    },
    methods: {
        grapheData(){
            this.metrique = this.$route.params.metrique;
            fetch(AppConfig.apiUrl+`/v1/metriques/nbre_users/${this.metrique}/annee`, {headers: {'Authorization': "Bearer " + localStorage.getItem('ms-token')}})
            .then(res => {
                if(res.status == 401){
                    localStorage.setItem('ancestor_link', window.location.href);
                    router.push({ name: 'login' });
                    Vue.swal({type: 'error', title: error.message});
                }
                return res.json()
            })
            .then(res => {
                this.debut = res.debut
                this.fin = res.fin
                const ctx = document.getElementById('planet-chart');
                const ctx_cumules = document.getElementById('planet-chart-cumules');
                new Chart(ctx, {
                    type: "line",
                        data: {
                            labels: ["Janvier", "Février", "Mars", "Avril", "Mai", "Juin", "Juillet", "Août", "Septembre", "Octobre", "Novembre", "Décembre"],
                            datasets: res.data
                        },
                        options: {
                            responsive: true,
                            lineTension: 1,
                            scales: {
                                yAxes: [
                                    {
                                    ticks: {
                                        beginAtZero: true,
                                        padding: 25
                                        }
                                    }
                                ]
                            }
                        }
                });
                new Chart(ctx_cumules, {
                    type: "line",
                        data: {
                            labels: ["Janvier", "Février", "Mars", "Avril", "Mai", "Juin", "Juillet", "Août", "Septembre", "Octobre", "Novembre", "Décembre"],
                            datasets: res.cumules
                        },
                        options: {
                            responsive: true,
                            lineTension: 1,
                            scales: {
                                yAxes: [
                                    {
                                    ticks: {
                                        beginAtZero: true,
                                        padding: 25
                                        }
                                    }
                                ]
                            }
                        }
                });
            })
        }
    },
    mounted() {
        this.grapheData();
    }
  }
  </script>

  <style scoped>

  </style>